/*
  Shared button FX enhancer — mirrors the featured-collections wave/burst
  behavior for sections using the plain button snippet. CSS lives in
  custom-styles.css (ygPowerBurst / ygEnergyPulse keyframes).
*/
(function () {
  var SCOPES = [
    '.shopify-section--blog-posts .button',
    '.shopify-section--multiple-media-with-text .button',
    '.shopify-section--apps .button'
  ].join(', ');

  function enhance() {
    document.querySelectorAll(SCOPES).forEach(function (btn) {
      if (btn.hasAttribute('data-yg-fx-enhanced')) return;
      btn.setAttribute('data-yg-fx-enhanced', 'true');

      btn.style.borderRadius = getComputedStyle(document.documentElement).getPropertyValue('--button-border-radius') || '12px';

      if (!btn.querySelector('span:not(.power-burst)')) {
        var text = btn.textContent.trim();
        btn.innerHTML = '<span>' + text + '</span>';
      }

      var burst = document.createElement('div');
      burst.classList.add('power-burst');
      btn.appendChild(burst);

      btn.addEventListener('click', function () {
        burst.style.animation = 'none';
        void burst.offsetWidth;
        burst.style.animation = 'ygPowerBurst 0.8s cubic-bezier(0.1, 0.8, 0.2, 1) forwards';
        btn.style.animation = 'ygEnergyPulse 0.8s ease-out';
        setTimeout(function () { btn.style.animation = ''; }, 800);
      });
    });
  }

  function boot() {
    enhance();
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.addedNodes.length) setTimeout(enhance, 50);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
